/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiEntitySchemaFieldType } from './InternalApiEntitySchemaFieldType';
import {
    InternalApiEntitySchemaFieldTypeFromJSON,
    InternalApiEntitySchemaFieldTypeFromJSONTyped,
    InternalApiEntitySchemaFieldTypeToJSON,
    InternalApiEntitySchemaFieldTypeToJSONTyped,
} from './InternalApiEntitySchemaFieldType';
import type { InternalApiEntitySchemaFieldFeature } from './InternalApiEntitySchemaFieldFeature';
import {
    InternalApiEntitySchemaFieldFeatureFromJSON,
    InternalApiEntitySchemaFieldFeatureFromJSONTyped,
    InternalApiEntitySchemaFieldFeatureToJSON,
    InternalApiEntitySchemaFieldFeatureToJSONTyped,
} from './InternalApiEntitySchemaFieldFeature';

/**
 * 
 * @export
 * @interface InternalApiEntitySchemaField
 */
export interface InternalApiEntitySchemaField {
    /**
     * 
     * @type {string}
     * @memberof InternalApiEntitySchemaField
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiEntitySchemaField
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiEntitySchemaField
     */
    fieldName: string;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiEntitySchemaField
     */
    isMulti: boolean;
    /**
     * 
     * @type {string}
     * @memberof InternalApiEntitySchemaField
     */
    parentId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiEntitySchemaField
     */
    enumOptions?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiEntitySchemaField
     */
    isNullable: boolean;
    /**
     * 
     * @type {number}
     * @memberof InternalApiEntitySchemaField
     */
    sortOrder: number;
    /**
     * 
     * @type {InternalApiEntitySchemaFieldType}
     * @memberof InternalApiEntitySchemaField
     */
    type: InternalApiEntitySchemaFieldType;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiEntitySchemaField
     */
    searchable: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiEntitySchemaField
     */
    hidden: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiEntitySchemaField
     */
    hiddenInSearchResults: boolean;
    /**
     * 
     * @type {Array<InternalApiEntitySchemaFieldFeature>}
     * @memberof InternalApiEntitySchemaField
     */
    features?: Array<InternalApiEntitySchemaFieldFeature>;
}



/**
 * Check if a given object implements the InternalApiEntitySchemaField interface.
 */
export function instanceOfInternalApiEntitySchemaField(value: object): value is InternalApiEntitySchemaField {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('fieldName' in value) || value['fieldName'] === undefined) return false;
    if (!('isMulti' in value) || value['isMulti'] === undefined) return false;
    if (!('isNullable' in value) || value['isNullable'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('searchable' in value) || value['searchable'] === undefined) return false;
    if (!('hidden' in value) || value['hidden'] === undefined) return false;
    if (!('hiddenInSearchResults' in value) || value['hiddenInSearchResults'] === undefined) return false;
    return true;
}

export function InternalApiEntitySchemaFieldFromJSON(json: any): InternalApiEntitySchemaField {
    return InternalApiEntitySchemaFieldFromJSONTyped(json, false);
}

export function InternalApiEntitySchemaFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiEntitySchemaField {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'displayName': json['displayName'],
        'fieldName': json['fieldName'],
        'isMulti': json['isMulti'],
        'parentId': json['parentId'] == null ? undefined : json['parentId'],
        'enumOptions': json['enumOptions'] == null ? undefined : json['enumOptions'],
        'isNullable': json['isNullable'],
        'sortOrder': json['sortOrder'],
        'type': InternalApiEntitySchemaFieldTypeFromJSON(json['type']),
        'searchable': json['searchable'],
        'hidden': json['hidden'],
        'hiddenInSearchResults': json['hiddenInSearchResults'],
        'features': json['features'] == null ? undefined : ((json['features'] as Array<any>).map(InternalApiEntitySchemaFieldFeatureFromJSON)),
    };
}

export function InternalApiEntitySchemaFieldToJSON(json: any): InternalApiEntitySchemaField {
    return InternalApiEntitySchemaFieldToJSONTyped(json, false);
}

export function InternalApiEntitySchemaFieldToJSONTyped(value?: InternalApiEntitySchemaField | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'displayName': value['displayName'],
        'fieldName': value['fieldName'],
        'isMulti': value['isMulti'],
        'parentId': value['parentId'],
        'enumOptions': value['enumOptions'],
        'isNullable': value['isNullable'],
        'sortOrder': value['sortOrder'],
        'type': InternalApiEntitySchemaFieldTypeToJSON(value['type']),
        'searchable': value['searchable'],
        'hidden': value['hidden'],
        'hiddenInSearchResults': value['hiddenInSearchResults'],
        'features': value['features'] == null ? undefined : ((value['features'] as Array<any>).map(InternalApiEntitySchemaFieldFeatureToJSON)),
    };
}

